import { render, staticRenderFns } from "./Policies.vue?vue&type=template&id=44d0bd2e&scoped=true&"
var script = {}
import style0 from "./Policies.vue?vue&type=style&index=0&id=44d0bd2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d0bd2e",
  null
  
)

export default component.exports